import axios from "../axios";
import * as fetchResponseHandling from "./../responseHandling/fetch";

async function fetchCourse(courseId) {
  const res = await axios.get(`/students/courses/${courseId}`);
  return fetchResponseHandling.parseResponse(res);
}

async function fetchCourses(libraryId) {
  const res = await axios.get(`/students/courses?course[library_id]=${libraryId}`);
  return fetchResponseHandling.parseResponse(res);
}

async function fetchEnrolledCourses() {
  const res = await axios.get(`/students/course_enrollments`);
  return fetchResponseHandling.parseResponse(res);
}

async function coursePreview(courseId) {
  const res = await axios.get(`/students/course_previews/${courseId}`);
  return fetchResponseHandling.parseResponse(res);
}

export {
  fetchCourse,
  fetchCourses,
  fetchEnrolledCourses,
  coursePreview,
};
